// extracted by mini-css-extract-plugin
module.exports = {"imgShowCard":"imgShowCard_imgShowCard__OUbde"};